(function () {
  if (!location.pathname.replace(/\/$/, '').endsWith('/pages/about-us')) return;
  var quote = 'movement became my medicine';
  function removeStaleFounderNodes() {
    document.querySelectorAll('[id*="wearth_founder_story_about"], #wearth-founder-about-page, [data-wearth-founder-story-v1]').forEach(function (el) {
      el.remove();
    });
    document.querySelectorAll('.wearth-customer-quote__quote').forEach(function (el) {
      if ((el.textContent || '').indexOf(quote) !== -1) {
        var root = el.closest('.wearth-customer-quote, [id^="wearth-founder"]');
        if (root) root.remove();
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeStaleFounderNodes);
  } else {
    removeStaleFounderNodes();
  }
})();
